import { useEffect } from "react";
import Footerr from "../components/Footerr/Footerr";
import { HeroSection } from "../components/home";

import { Header } from "../components/shared";
import WhatWeOffer from "../components/WhatWeOffer/WhatWeOffer";
import WhyTercesHome from "../components/WhyTercesHome/WhyTercesHome";
import NewCoreValues from "../components/CoreValues/NewCoreValues";
import AboutSection from "../components/home/AboutStory";
import CTASection from "../components/home/CTASection";
import ServicesSection from "../components/home/WhoweOffer";
import MeasurableImprovements from "../components/home/MeasurableImprovements";
import GeneralFAQs from "../components/FAQs/GeneralFAQs";
import usePageMeta from "../../seo/usePageMeta";
import { getGeneralFAQs } from "../components/FAQs/GeneralFAQsData";
import { useRegion } from "../../regions/RegionContext";

function Homer() {
  const { config } = useRegion();
  const generalFAQs = getGeneralFAQs(config.terminology);

  usePageMeta({
    title: config.seo.homeTitle,
    description: config.seo.homeDescription,
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: generalFAQs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    },
  });

  useEffect(() => {
    // Enable smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="home-page">
      <Header />
      <main className="home-content">
        <HeroSection />
        <MeasurableImprovements />
        <ServicesSection />
        <WhatWeOffer />
        <AboutSection />
        <WhyTercesHome />
        <NewCoreValues />
     
        <GeneralFAQs />
        {/* <CTASection /> */}
      </main>
      <Footerr />
    </div>
  );
}

export default Homer;
